module.exports = __webpack_public_path__ + "img/20220327_192215.25346b83.jpg";